import * as blink from './js/banner/blink';
import * as recommendations from './js/banner/recommendations';
import * as styles from './js/banner/styles';

export default { ...blink, ...recommendations, ...styles };
